import DimensiTeacher from "../../../../../components/categories/siakad/laporan_adab/penilaian/HomeTeacher";
export default function Home() {
  
  return (
    <DimensiTeacher />
  );
}
